import React, { useState, useEffect } from "react";
import { Table, Pagination } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { DatatableProps, TableData } from "../../data/interface"; // Ensure correct path


const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  originalData,
  enableRowSelection = true,
  onRowSelect,
  onDoubleClick,
  paginations,
  onRowSelectId,
  onclick,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<TableData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(7); // Adjust as per your requirement

  const onSelectChange = (newSelectedRowKeys: any[], newSelectedRows: TableData[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
    if (onRowSelect) {
      const selectedOriginalRows = newSelectedRows.map(row =>
        originalData?.find(data => data?.userAccountId === row?.id)
      );
      onRowSelect(selectedOriginalRows);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: any[], newSelectedRows: TableData[]) => {
      onSelectChange(newSelectedRowKeys, newSelectedRows);
    },
  };

  const onRow = (record: TableData) => ({
    onClick: () => {
      const key = record.key;
      let newSelectedRowKeys = [...selectedRowKeys];
      let newSelectedRows = [...selectedRows];

      if (newSelectedRowKeys.includes(key)) {
        newSelectedRowKeys = newSelectedRowKeys.filter((item) => item !== key);
        newSelectedRows = newSelectedRows.filter((item) => item.key !== key);
      } else {
        newSelectedRowKeys.push(key);
        newSelectedRows.push(record);
      }

      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(newSelectedRows);

      if (onRowSelect) {
        const selectedOriginalRows = newSelectedRows.map(row =>
          originalData?.find(data => data?.userAccountId === row?.id)
        );
        onRowSelect(selectedOriginalRows);
      }
    },
    onDoubleClick: () => {
      if (onDoubleClick) {
        onDoubleClick(record);
      }
    },
  });

  const onPageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
  };

  const itemRender = (page: number, type: string, originalElement: React.ReactNode) => {
    if (type === 'prev') {
      return <span><LeftOutlined />Previous</span>;
    }
    if (type === 'next') {
      return <span>Next <RightOutlined /></span>;
    }
    return originalElement;
  };

  return (
    <div>
      <Table
        className="table datanew dataTable no-footer"
        rowSelection={enableRowSelection ? rowSelection : undefined}
        columns={columns}
        dataSource={dataSource.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        onRow={onRow}
        pagination={false}
      />
      {paginations && (
        <div className="row mt-3">
          <div className="d-flex col-md-6 gap-2 align-items-center">
            <span>Show </span>
            <DropdownButton
              id="dropdown-basic-button"
              title={`${pageSize}`}
              onSelect={(e: any) => setPageSize(parseInt(e))}
              className="btn-sm"
            >
              {['7', '20', '50'].map((size) => (
                <Dropdown.Item className="p-1" key={size} eventKey={size}>
                  {`${size}`}
                </Dropdown.Item>
              ))}
            </DropdownButton>
            <span> entries</span>
          </div>
          <div className="d-flex col-md-6 justify-content-end">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={dataSource.length}
              itemRender={itemRender}
              onChange={onPageChange}
              onShowSizeChange={(current, size) => setPageSize(size)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Datatable;
